import React from 'react';
import Icon from '../../../components/AppIcon';

const TechnologyStack = ({ category, icon, technologies, description }) => {
  return (
    <div className="p-6 md:p-8 bg-card border border-border rounded-2xl hover:border-primary/50 transition-all duration-300">
      <div className="flex items-start gap-4 mb-4 md:mb-6">
        <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name={icon} size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg md:text-xl font-bold font-heading text-foreground mb-2">
            {category}
          </h3>
          <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {technologies?.map((tech, index) => (
          <span 
            key={index}
            className="px-3 py-1.5 bg-muted text-foreground text-xs md:text-sm font-medium rounded-lg hover:bg-primary/20 hover:text-primary transition-colors duration-300"
          >
            {tech}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TechnologyStack;